import React from "react";

import Chatbot from "../components/Chatbot";
import SEO from "../components/SEO";

const Privacy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy - OpenMind"
        description="Openmind's Privacy Policy"
        canonical="https://openmind.org/privacy"
      />
      <div className="min-h-screen bg-white">
        <main className="flex-grow container mx-auto px-8 py-16">
          <div className="flex justify-between items-center max-md:flex-col max-md:items-start">
            <h1 className="text-[48px] leading-[123%] tracking-[-1.44px] max-md:text-[28px] max-md:tracking-[-1.04px] max-sm:tracking-[-0.96px]">
              Privacy Policy
            </h1>

            {/* graphic blocks*/}
            <div className="grid grid-cols-6 grid-rows-2 gap-0 w-[60%] h-8 max-md:mt-4 max-sm:w-[70%] justify-self-end ml-auto">
              <div className="bg-[#7de8ff] row-start-2 row-end-3 col-start-1 col-end-2" />
              <div className="col-start-2 col-end-5 row-start-1 row-end-2 bg-[#08A887]" />
              <div className="col-start-5 col-end-7 row-start-2 row-end-3 bg-[#0965AB]" />
            </div>
          </div>

          <div className="flex gap-12 max-md:flex-col mt-20 font-creato">
            <div className="w-1/2 max-md:w-full">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold max-md:text-xl max-sm:text-lg">
                  1. Introduction
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  Openmind (“we,” “us,” or “our”) respects your privacy and is
                  committed to protecting your personal information. This
                  Privacy Policy explains how we collect, use, and protect the
                  information you provide when you visit our website,
                  openmind.org.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  2. Information We Collect
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  We may collect the following types of information:
                </p>

                <ul className="list-disc pl-6 max-md:text-sm max-sm:text-xs">
                  <li>
                    <strong>Personal Information:</strong> Name, email address,
                    phone number, or other contact details that you voluntarily
                    provide when you register, contact us, or subscribe to our
                    services.
                  </li>
                  <li>
                    <strong>Usage Data:</strong> Information about how you use
                    and interact with the Website, such as your IP address,
                    browser type, pages visited, and time spent on the Website.
                  </li>
                  <li>
                    <strong>Cookies:</strong> We may use cookies and similar
                    tracking technologies to enhance your experience on our
                    Website.
                  </li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  3. How We Use Your Information
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  We may use your information for the following purposes:
                </p>
                <ul className="list-disc pl-6 max-md:text-sm max-sm:text-xs">
                  <li>To provide and maintain the Website</li>
                  <li>To personalize your experience</li>
                  <li>To improve our products and services</li>
                  <li>
                    To communicate with you, including responding to inquiries
                    or sending updates
                  </li>
                  <li>To analyze Website usage and trends</li>
                </ul>
              </section>
            </div>

            <div className="w-1/2 max-md:w-full">
              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  4. Sharing Your Information
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  We do not sell, trade, or rent your personal information to
                  third parties. We may share your information with trusted
                  service providers who assist us in operating the Website,
                  provided they agree to keep your information confidential.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  5. Data Security
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  We implement appropriate security measures to protect your
                  personal information from unauthorized access, alteration, or
                  disclosure. However, no method of transmission over the
                  internet is 100% secure, and we cannot guarantee absolute
                  security.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  6. Your Rights
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  You have the right to access, correct, or delete your personal
                  information. You may also opt out of any communications from
                  us. To exercise these rights, please contact us at{" "}
                  <a
                    href="mailto:hello@openmind.org"
                    className="text-blue-500 underline"
                  >
                    hello@openmind.org
                  </a>
                  .
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  7. Changes to This Privacy Policy
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  We may update this Privacy Policy from time to time. Any
                  changes will be posted on this page, and we encourage you to
                  review it periodically.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold max-md:text-xl max-sm:text-lg">
                  8. Contact Us
                </h2>
                <p className="max-md:text-sm max-sm:text-xs">
                  If you have any questions or concerns about this Privacy
                  Policy, please contact us at{" "}
                  <a
                    href="mailto:hello@openmind.org"
                    className="text-blue-500 underline"
                  >
                    hello@openmind.org
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>
        {/* Chatbot positioned according to Figma design */}
        <Chatbot />
      </div>
    </>
  );
};

export default Privacy;
